import { Trans } from "@lingui/macro";
import Image from "next/image";
import { ReactNode } from "react";
import styled from "styled-components";
import { Button } from "~/guidelines/Button";
import { ArrowBack } from "~/guidelines/Icon";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import { body1, heading2, heading3, heading5 } from "~/guidelines/Typography";
import EncoreMieuxSigle from "~/guidelines/Logo/EncoreMieuxSigle.svg";

const Container = styled.div`
  max-width: 700px;
  margin: ${({ theme }) => theme.spacing(8, "auto")};
  padding: ${({ theme }) => theme.spacing(0, 6)};

  ${mediaQueries.md()} {
    margin: ${({ theme }) => theme.spacing(10, "auto")};
  }
`;

const LogoWrapper = styled.div`
  max-width: 150px;
  margin: ${({ theme }) => theme.spacing(0, "auto", 6, "auto")};

  ${mediaQueries.md()} {
    margin: ${({ theme }) => theme.spacing(0, "auto", 20, "auto")};
  }
`;

const MarkdownStyle = styled.div`
  ${body1};

  overflow-wrap: break-word;
  word-wrap: break-word;

  & h1 {
    ${heading2};
    text-align: center;
  }

  & h2 {
    ${heading3};
  }

  & h3 {
    ${heading5};
  }
`;

const LegalPageLayout = ({
  homePageUrl,
  children,
}: {
  homePageUrl: string;
  children: ReactNode;
}) => {
  return (
    <Container>
      <LogoWrapper>
        <Image
          src={EncoreMieuxSigle}
          style={{ width: "100%", height: "auto" }}
          sizes="100vw"
          alt=""
        />
      </LogoWrapper>

      <div>
        <Button
          href={homePageUrl}
          leadingIcon={<ArrowBack />}
          kind="quaternary"
        >
          <Trans>Back to website</Trans>
        </Button>
      </div>
      <MarkdownStyle>{children}</MarkdownStyle>
    </Container>
  );
};

export default LegalPageLayout;
